import {captureError} from '../../../../../utils/log';
import documentService from '../../../../../services/document/DocumentService';

export const getDocuments = organisationId => new Promise((resolve, reject) => {
  documentService.search(organisationId)
    .then(documents => {
      resolve(documents);
    })
    .catch(error => {
      captureError('Error while fetching organisation documents', error);
      reject();
    });
});
